import { render } from "./FormCreate.vue?vue&type=template&id=790ac93b&scoped=true"
import script from "./FormCreate.vue?vue&type=script&lang=js"
export * from "./FormCreate.vue?vue&type=script&lang=js"

import "./FormCreate.vue?vue&type=style&index=0&id=790ac93b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790ac93b"]])

export default __exports__